import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const BASE = `${config.BASE_URL}/notifications`;

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

export async function getMyNotifications(limit = 100) {
  const qs = limit != null ? `?limit=${encodeURIComponent(String(limit))}` : "";
  const res = await authFetch(`${BASE}${qs}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || "Failed to load notifications");
  }
  return payload;
}
